import React, { Component } from 'react';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, InputGroup, Button, Form, Dropdown, Table, Tooltip, OverlayTrigger } from 'react-bootstrap';
import RightSideModalSchedular from '../rightside-modal/right-modal-schedular';
import apiError from '../../error';
import axios from '../../axios';
import { debounce } from '../../function';
import Pagination from "react-js-pagination";
import Loader from '../loader/loader';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { PiPlus } from 'react-icons/pi';
import { PiFileCsvDuotone, PiFilePdfDuotone } from 'react-icons/pi';
import { getReportTypeBadges } from './report-type';
class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            limit: 10,
            search: '',
            page: 1,
            show: false,
            loading: true,
            showModal: false,
            campaignReportSchedulers: [],
            selectedCampaignReportScheduler: {}
        }
    }
    renderRecipientsList = (recipients) => {
        if (!recipients) return "";
        const maxVisible = 3;
        const visibleItems = recipients.slice(0, maxVisible);
        const remainingCount = recipients.length - maxVisible;

        return (
            <ul className='cirle-list'>
                {visibleItems.map((recipient, index) => (
                    recipient = recipient.split('.'),
                    recipient = (recipient[0] && recipient[0][0]?.toUpperCase() || "") + (recipient[1] && recipient[1][0]?.toUpperCase() || ""),
                    <li key={index}>{recipient}</li>
                ))}
                {remainingCount > 0 && <li>+{remainingCount}</li>}
            </ul>
        );
    }

    loadDebounced = debounce(() => {
        this.fetchcampaignReportSchedulers();
    }, 500)

    fetchcampaignReportSchedulers = async () => {
        try {
            this.setState({ loading: true });
            const response = await axios.get('/api/pdfReport/campaign-report-scheduler', {
                params: {
                    page: this.state.page,
                    limit: this.state.limit,
                    search: this.state.search
                }
            });
            this.setState({ campaignReportSchedulers: response.data.campaignReportSchedulers, count: response.data.count, loading: false });
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }
    componentDidMount() {
        this.fetchcampaignReportSchedulers();
    }

    handleCampaignReportDelete = async (id) => {
        try {
            let shouldDelete = await swal({
                title: "Are you sure you want to delete this campaign report scheduler?",
                icon: "warning",
                buttons: ["No", "Yes"],
                dangerMode: true,
            })
            // let shouldDelete = await swalAlert("Warning", "Are you sure you want to delete this scheduled campaign report?", "warning", true, "Yes", true);
            if (!shouldDelete) return;
            this.setState({ loading: true });
            const response = await axios.delete(`/api/pdfReport/delete-campaign-report-scheduler/${id}`);
            toast.success(response.data.message);
            this.setState({ loading: false });
            this.fetchcampaignReportSchedulers();
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }

    getDate(date) {
        if (!date) return "---";
        date = new Date(date);
        if (!isNaN(date.getTime())) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            hours = String(hours).padStart(2, '0');
            return `${day}-${month}-${year} | ${hours}:${minutes} ${ampm}`;
        } else return '---';
    }
    updateCampaignReportStatus = async (id, status) => {
        try {
            this.setState({ loading: true });
            const response = await axios.post(`/api/pdfReport/update-campaign-report-status/${id}`, { status });
            toast.success(response.data.message);
            this.setState({ loading: false });
            this.fetchcampaignReportSchedulers();
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }

    render() {

        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Report Scheduler</h4>
                            </div>
                        </div>
                        <div className="col-md-8 flexFilterButtons">
                            <div className="btn-container float-right d-flex align-items-center">
                                <Button className="btn btn-primary btn-with-icon" onClick={() => this.setState({ showModal: true })} > <PiPlus /> Add Scheduler</Button>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="contentbar">
                <div className='filter-without-border'>
                    <div className="row align-items-center">
                        <div className="col-md-3">
                        <div className="positionSearchIcon">
                                <InputGroup className="search-wrap">
                                    <FormControl
                                        type="text"
                                        placeholder="Search"
                                        className="inputSearch mr-sm-2 form-control"
                                        value={this.state.search}
                                        onChange={(e) => this.setState({ search: e.target.value, page: 1 }, this.loadDebounced)}
                                    /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                </InputGroup>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="rightFilters">
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="tableContainerWrapInner min-width-th" style={{ borderRadius: '0' }}>
                        <Table>
                            <thead>
                                <tr>
                                    <th className="th-20">Campaign Name</th>
                                    <th>Attack Vectors</th>
                                    <th>Recipients</th>
                                    <th className='th-center'>Followup - Campaign</th>
                                    <th>Frequency</th>
                                    <th>Completes On</th>
                                    <th>Status</th>
                                    <th>Report Type</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(this.state.campaignReportSchedulers?.length) ? this.state.campaignReportSchedulers?.map(srs =>
                                    <tr>
                                        <td className="th-20" title={srs?.campaign?.name || ""} style={{ cursor: 'pointer' }} onClick={() => this.setState({ showModal: true, selectedCampaignReportScheduler: srs })}>{srs?.campaign?.name}</td>
                                        <td >{srs?.campaign?.attack_type?.name}</td>
                                        <td>
                                            {this.renderRecipientsList(srs.emails)}
                                        </td>
                                        <td className='td-center'>
                                            {srs.campaign.simulations?.length - 1}

                                            {/* <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-emails-${srs.id}`}>
                                                        {srs.campaign.simulations && srs.campaign.simulations.length > 1
                                                            ? <ul>
                                                                {srs.campaign.simulations?.map((c, index) => (
                                                                    index < srs.campaign.simulations.length - 1 ? <li key={index}>{`${srs.campaign.name}(${index+2})`}</li> : null
                                                                ))}
                                                            </ul>
                                                            : "No Follow-up Campaign"}
                                                    </Tooltip>
                                                }
                                            >
                                                <span className="badge badge-pill badge-soft-secondary badge-custom-css" style={{ cursor: "pointer" }}>
                                                   {srs.campaign.simulations?.length - 1}{" "} <AiOutlineInfo className='tooltip-icon' />
                                                </span>
                                            </OverlayTrigger> */}
                                        </td>

                                        <td >{srs.frequency && srs.frequency === "daily" ? "Daily" : "On Expiry"}</td>
                                        <td>{this.getDate(srs.completesOn)}</td>
                                        <td>
                                            <span className={`badge badge-pill ${srs.status === "Active" ? 'badge-soft-primary' : 'badge-soft-success'}`}>{srs.status}</span>
                                        </td>
                                        <td>
                                            <div className="report-type-badges">
                                                {getReportTypeBadges(srs.reportType).map(reportType => (
                                                    <span key={reportType.value} className="badge badge-pill badge-soft-secondary report-type-badge">
                                                        {reportType.value === 'executive'
                                                            ? <PiFilePdfDuotone className="report-type-pdf-icon" />
                                                            : <PiFileCsvDuotone className="report-type-csv-icon" />}
                                                        {reportType.label}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                        <td>
                                            <Dropdown
                                                className="action-dropdown dropdownIcon"
                                                ref={this.selectRef}
                                            >
                                                <Dropdown.Toggle
                                                    className="btn-only"
                                                    id="dropdown-basic"
                                                >
                                                    <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => this.setState({ showModal: true, selectedCampaignReportScheduler: srs })}>
                                                        Edit
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => this.handleCampaignReportDelete(srs.id)}
                                                    >
                                                        Delete
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>

                                ) : <tr><td colSpan={9} className='text-center'>No Schedule Report Found </td></tr>}
                            </tbody>
                        </Table>

                    </div>

                    {this.state.count > 0 && (
                        <div className="pagination-Wrap" style={{ border: '1px solid #dfe2e6', borderTop: 'none' }}>
                            <div className="row">
                                <div className="col-md-6">
                                    {!this.state['loading'] ?
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            activePage={this.state.page}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.count}
                                            onChange={(pageNumber) => this.setState({ page: pageNumber }, () => this.fetchcampaignReportSchedulers())}
                                        /> : <Loader />
                                    }
                                </div>
                                <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                    <div className="w-100 pgCount">
                                        <p>
                                            {this.state.count === 0 ? 0 : this.state.page * this.state.limit + 1 - this.state.limit}-
                                            {this.state.page * this.state.limit > this.state.count ? this.state.count : this.state.page * this.state.limit} of {this.state.count} records
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <RightSideModalSchedular
                    show={this.state.showModal}
                    handleModal={(status) => this.setState({ showModal: status }, () => {
                        if (!status) {
                            this.setState({ selectedCampaignReportScheduler: {} });
                            this.fetchcampaignReportSchedulers();
                        }
                    })}
                    campaignReportScheduler={this.state.selectedCampaignReportScheduler}
                ></RightSideModalSchedular>
                {this.state.loading && <Loader />}
            </div>
        );
    }
}

export default Schedule;
